export default "__VITE_ASSET__Dtl_cOx4__";